<template>
    <div class="whatsapp-button" @click="openWhatsApp" v-if="$store.getters.websiteInfo.show_whatsapp_widget==1">
      <img :src="$config.whats_icon" />
    </div>
  </template>
  
  <script>
  import { GET_WEBSITE_INFO } from '../../store/actions';
  import {ADD_KEYWORDS} from '../../../common/store/actions';

  export default {
    data(){
      return {
        keywords:{
          preferences:[]
          
        }
      }
    },

    methods: {
      openWhatsApp() {
        this.keywords.preferences.push({
          value: '',
          type: "whatsapp_click"
        })
        this.$store.dispatch(ADD_KEYWORDS, this.keywords)
        window.open("https://wa.me/"+ this.$store.getters.websiteInfo.whatsapp_number.replace(/\s/g, ''), '_blank');
      }
    },
    async mounted(){
        await this.$store.dispatch(GET_WEBSITE_INFO);
    }

  };
  </script>
  
  <style lang='scss' scoped>
  .whatsapp-button {
    position: fixed;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    bottom: 20px;
    right: 20px;
    width: 68px;
    height: 68px;
    color: black;
    background-color: white;
    //border: 1px solid black;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transform: scale(1);
    z-index: 2000;

    @media screen and (max-width:500px) {
        width: 50px;
        height: 50px;
    }
  }

  .whatsapp-button:hover{
    transform: scale(1.1);
    background-color: #f5f5f5;
  }
  
  .whatsapp-button img {
    width: 35px;
    height: auto;
    @media screen and (max-width:500px) {
        width: 25px;
       
    }
  }
  </style>